import React from 'react';
import { Button, ButtonVariant } from '@cmhc-schl/hearth-ui';
import { ArrearsFlyoutFooterMainContent } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutFooterMainContent';
import { useTranslation } from 'react-i18next';

type ArrearsFlyoutFooterProps = {
  closeFlyout: () => void;
  onSave: () => void;
  readOnly: boolean;
};
export const ArrearsFlyoutFooter = ({
  closeFlyout,
  onSave,
  readOnly
}: ArrearsFlyoutFooterProps) => {
  return readOnly ? (
    <ArrearsFlyoutReadOnlyFooter closeFlyout={closeFlyout} />
  ) : (
    <ArrearsFlyoutEditorFooter closeFlyout={closeFlyout} onSave={onSave} />
  );
};

export const ArrearsFlyoutReadOnlyFooter = ({ closeFlyout }: { closeFlyout: () => void }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  return (
    <ArrearsFlyoutFooterMainContent>
      <Button
        variant={ButtonVariant.SECONDARY}
        customStyles={{ flexGrow: '1', maxWidth: 'none' }}
        name={t('arrearsFlyout.closeButton')}
        text={t('arrearsFlyout.closeButton')}
        onClick={closeFlyout}
      />
    </ArrearsFlyoutFooterMainContent>
  );
};

export const ArrearsFlyoutEditorFooter = ({
  closeFlyout,
  onSave
}: {
  closeFlyout: () => void;
  onSave: () => void;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  const buttonStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 0 0'
  };
  return (
    <ArrearsFlyoutFooterMainContent>
      <Button
        variant={ButtonVariant.SECONDARY}
        customStyles={buttonStyles}
        name={t('arrearsFlyout.cancelButton')}
        text={t('arrearsFlyout.cancelButton')}
        onClick={closeFlyout}
      />
      <Button
        variant={ButtonVariant.PRIMARY}
        customStyles={buttonStyles}
        name={t('arrearsFlyout.saveButton')}
        text={t('arrearsFlyout.saveButton')}
        onClick={onSave}
      />
    </ArrearsFlyoutFooterMainContent>
  );
};
